import { IconSizeEnum, MessageInfoFilledIcon, Typography } from '@acceso/design-system';
import clsx from 'clsx';

type THighlightContainerProps = {
  children: React.ReactNode;
  className?: string;
  title?: string;
};

export function HighlightContainer({ title, children, className }: THighlightContainerProps) {
  return (
    <div className={clsx('w-full', className)}>
      {title && (
        <div className="flex items-center gap-1">
          <Typography>{title}</Typography>

          <MessageInfoFilledIcon size={IconSizeEnum.MD} className="text-accent-active-primary-30" />
        </div>
      )}

      <div className="my-4 flex w-full flex-col gap-4 bg-layout-primary p-4">{children}</div>
    </div>
  );
}
